<template>
    <div class="index">
        <div class="out_box">
            <div class="header_title u-f u-ac">
                <div @click="backpage" class="icon iconfont icon-a-zuojiantouzhixiangzuojiantou backbtn"></div>忘记密码
            </div>
            <div class="lc_body">
                <el-form ref="ruleForm" :rules="rules" :model="form">
                    <el-form-item prop="phone" class="username">
                        <el-input placeholder="请输入管理员手机号" v-model="form.phone">
                            <template slot="prepend">+86</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="code" class="username">
                        <el-input placeholder="请输入验证码" v-model="form.code">
                            <el-button slot="append" v-if="isshowbtn" @click="getcode">获取验证码</el-button>
                            <el-button slot="append" v-else><em style="margin-right:5px">{{codecount}}</em>秒后重新获取
                            </el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="pwd" class="username">
                        <el-input placeholder="请输入新密码" show-password type="" v-model="form.pwd" autocomplete= "new-password">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="qpwd" class="username">
                        <el-input placeholder="请再次输入新密码" show-password v-model="form.qpwd" autocomplete= "new-password">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="sub_b">
                    <el-button type="primary" :loading='subloading' @click="submit('ruleForm')">修改</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    phone: '',
                    code: '',
                    pwd: '',
                    qpwd: ''
                },
                rules: {
                    phone: [{
                        required: true,
                        message: '请输入管理员手机号',
                        trigger: 'blur'
                    }],
                    code: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }],
                    pwd: [{
                        required: true,
                        message: '请输入新密码',
                        trigger: 'blur'
                    }],
                    qpwd: [{
                        required: true,
                        message: '请再次输入新密码',
                        trigger: 'blur'
                    }]
                },
                isshowbtn: true,
                codecount: 0,
                subloading: false,
            }
        },
        mounted() {},
        methods: {

            getcode() {
                if (this.form.phone == '') return this.$message('请填写管理员手机号')
                if (!/^1[3-9]\d{9}$/.test(this.form.phone)) return this.$message('手机号格式不正确')
                this.axios.get(
                    `/admin/sendmsg/ForgetPwdCode?phone=${this.form.phone}&source=manager&type=forgetPwdCode`).then(
                    res => {
                        if (res.data.code == 200) {
                            this.$message.success('验证码发送成功，请注意查收！')
                            this.codeInterval()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
            },
            codeInterval() {
                this.isshowbtn = false
                this.codecount = 60
                let timer = setInterval(() => {
                    this.codecount--
                    if (this.codecount == 0) {
                        clearInterval(timer)
                        this.codecount = 0
                        this.isshowbtn = true
                    }
                }, 1000)
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.form.pwd != this.form.qpwd) return this.$message('两次密码输入不一致！')
                        this.subloading = true
                        let params = {
                            code: this.form.code,
                            phone: this.form.phone,
                            password: this.form.pwd,
                        }
                        this.axios.post('/admin/manager/pwd/forgetPwd', params).then(res => {
                            this.subloading = false
                            if (res.data.code == 200) {
                                this.$message.success('密码修改成功！')
                                setTimeout(() => {
                                    this.$router.go(-1)
                                }, 1000)
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },






            backpage() {
                this.$router.go(-1)
            },


        }
    }
</script>

<style lang="scss" scoped>
    #app {
        height: 100%;
    }

    .index {
        background-image: url('../../assets/imgs/login_bgimg.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        height: 100vh;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;

        .out_box {
            background-color: #fff;
            border-radius: 8px;

            .header_title {
                padding: 20px 25px;
                font-size: 20px;
                font-weight: 600;

                .backbtn {
                    font-size: 25px;
                    margin-right: 15px;
                    cursor: pointer;
                }

            }

            .lc_body {
                min-height: 550px;
                width: 500px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 20px 20px;

                .sub_b {
                    text-align: right;
                }

            }
        }
    }
</style>